import { t } from '../i18n';

import { CHIP_COLOR, OPTION_COLOR_CYCLE } from './database-rows';
import type { ChipColor } from '@noti/shared';

/**
 * The tray for editing one option: a name field, the six chip colours and delete.
 * Shared by the cell dropdown, the multi-cell and the Properties panel, so an
 * option looks and behaves the same everywhere. Geometry is `opt__*` in workspace.css.
 */

export interface OptionEditorProps {
  name: string;
  color: ChipColor;
  onName: (value: string) => void;
  onSave: () => void;
  onRecolor: (color: ChipColor) => void;
  onDelete: () => void;
}

export function OptionEditor({
  name,
  color,
  onName,
  onSave,
  onRecolor,
  onDelete,
}: OptionEditorProps): React.ReactElement {
  return (
    <div className="opt__editor">
      <input
        className="ni"
        value={name}
        aria-label={t('database.renameOption')}
        onChange={(event) => onName(event.target.value)}
        onKeyDown={(event) => {
          if (event.key === 'Enter') onSave();
        }}
      />
      <div className="opt__swatches">
        {OPTION_COLOR_CYCLE.map((option) => (
          <button
            key={option}
            type="button"
            className="opt__swatch"
            title={option}
            aria-label={option}
            style={{
              background: CHIP_COLOR[option].bg,
              borderColor: option === color ? 'var(--color-primary)' : 'transparent',
            }}
            onClick={() => onRecolor(option)}
          />
        ))}
      </div>
      <button type="button" className="opt__delete" onClick={onDelete}>
        {t('database.deleteOption')}
      </button>
    </div>
  );
}
